import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { Dispatch } from 'redux';
import { dialogClear } from '../../../stores/auth/actionCreators';
import { isLoggedIn, sendPasswordResetSuccess, updateAccountSuccess } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import CenterContainer from '../../layout/CenterContainer';
import UpdateAccountDialog from './UpdateAccountDialog';
import UpdateAccountSuccess from './UpdateAccountSuccess';

interface Props extends LocalizeContextProps, RouteComponentProps {
    success: boolean;

    dialogClear: () => void;
}

class UpdateAccountPage extends React.Component<Props> {
    public componentWillMount() {
        this.props.dialogClear();
    }

    public render() {
        const t = this.props.translate;
        return (
            <CenterContainer>
                {this.props.success ?
                    <UpdateAccountSuccess /> :
                    <UpdateAccountDialog />
                }
            </CenterContainer >
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    isLoggedIn: isLoggedIn(state),
    success: updateAccountSuccess(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    dialogClear: () => dispatch(dialogClear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(UpdateAccountPage)));
